import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { getProductById } from "../../api/web";
import moment from "moment";
import { formatMetricTonnesFromKg, formatQuantityAsMetricTonnes } from "../../utils/formatNumbers";

const ProductDetail = (props) => {

    const id = props.match.params.id;
    const [initialLoading, setInitialLoading] = useState(true);
    const [product, setProduct] = useState(null);

    useEffect(() => {
        getProductById(id).then((response) => {
            if (!response.error) {
                setProduct(response.payload);
            }
            setInitialLoading(false);
        });
    }, [id]);

    const memberDisplay = (m) => {
        if (!m) return '—';
        if (typeof m === 'object') {
            const name = [m.first_name, m.last_name].filter(Boolean).join(' ');
            return name || m.username || m.email || m.id || '—';
        }
        return `#${m}`;
    };

    const cropDisplay = (c) => {
        if (!c) return '—';
        if (typeof c === 'object') return c.name ?? c.id ?? '—';
        return `#${c}`;
    };

    const gradeDisplay = (g) => {
        if (!g) return '—';
        if (typeof g === 'object') return g.tier ?? g.id ?? '—';
        return `#${g}`;
    };

    if (initialLoading) {
        return (
            <div className="content-body">
                <div className="container d-flex justify-content-center ht-100p">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mg-t-10">Loading product</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!product) {
        return (
            <div className="content-body">
                <div className="container pd-x-0">
                    <div className="mg-b-20">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/product">Products</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Not found</li>
                            </ol>
                        </nav>
                        <p className="tx-danger">Product not found.</p>
                        <Link to="/product" className="btn btn-sm btn-primary">Back to Products</Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/product">Products</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Product #{product.id}</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-5 tx-spacing--1">Product #{product.id}</h4>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="tx-color-03 tx-13">{cropDisplay(product.crop)} — {memberDisplay(product.member)}</span>
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        <Link to="/product" className="btn btn-sm pd-x-15 btn-secondary btn-uppercase">
                            <i className="wd-10 mg-r-5 fa fa-arrow-left"></i> Back to list
                        </Link>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header">
                                <h6 className="mg-b-0">Information</h6>
                            </div>
                            <div className="card-body">
                                <div className="row row-sm">
                                    <div className="col-md-6">
                                        <p><strong>Crop:</strong> {cropDisplay(product.crop)}</p>
                                        <p><strong>Grade:</strong> {gradeDisplay(product.grade)}</p>
                                        <p><strong>Quantity:</strong> {formatQuantityAsMetricTonnes(product.quantity, product.units)}</p>
                                        <p><strong>Standard quantity (t):</strong> {formatMetricTonnesFromKg(product.standard_quantity)}</p>
                                        <p><strong>Units:</strong> {product.units ?? '—'}</p>
                                        <p><strong>Number of 50kg bags:</strong> {product.num_of_50kg_bags != null ? product.num_of_50kg_bags : '—'}</p>
                                        <p><strong>Member:</strong> {memberDisplay(product.member)}</p>
                                        <p><strong>Cooperative product:</strong> {product.is_cooperative_product ? 'Yes' : 'No'}</p>
                                    </div>
                                    <div className="col-md-6">
                                        <p><strong>Total confirmed:</strong> {product.is_total_confirmed ? 'Yes' : 'No'}</p>
                                        <p><strong>Quantity confirmed:</strong> {product.is_quantity_confirmed ? 'Yes' : 'No'}</p>
                                        <p><strong>Cooperative group:</strong> {product.cooperative_group && typeof product.cooperative_group === 'object' ? (product.cooperative_group.group_name ?? product.cooperative_group.id) : (product.cooperative_group ?? '—')}</p>
                                        <p><strong>Date created:</strong> {product.date_created ? moment(product.date_created).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                        <p><strong>Date modified:</strong> {product.date_modified ? moment(product.date_modified).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                        {product.description ? (
                                            <p><strong>Description:</strong><br/><span className="tx-color-03">{product.description}</span></p>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProductDetail;
